import { createStyles } from '@mui/styles';

// Utils
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    "@keyframes onloadup": {
        "0%": {
            opacity: 0,
            transform: "translateY(65px)"
        },
        "100%": {
            opacity: 1,
            transform: "translateY(0)"
        }
    },
    addBankDetailsContainer: {
        background: '#F5F5F5',
        color: '#4a4a4a',
        fontSize: 16,
        letterSpacing: '-0.5px',
        height: '100%',
        padding: '39px 35px',
        animationName: `$onloadup`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        '@media(max-width: 1200px)': {
            paddingLeft: 110,
        },
        '@media(max-width: 768px)': {
            padding: 30,
        },
        '@media(max-width: 480px)': {
            padding: 20,
        }
    },
    addBankDetailsContainerTitle: {
        maxWidth: 537,
        color: '#4a4a4a',
        marginBottom: 30,
        '@media(max-width: 768px)': {
            textAlign: 'center',
            margin: '0 auto 40px'
        },
        '& > h1': {
            fontSize: 26,
            lineHeight: '34px',
            letterSpacing: '-0.5px',
            margin: '0 0 10px 0',
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                fontSize: '2.0rem',
            },
        },
        '& > p': {
            fontSize: 16,
            lineHeight: '24px',
            letterSpacing: '0',
            margin: 0,
            [theme.breakpoints.down('sm')]: {
                fontSize: '1.4rem',
                lineHeight: 1.45
            },
        }
    },
    addBankDetailsFormSteps: {
        width: '100%',
        minWidth: '320px',
        maxWidth: '537px',
        '& > div': {
            margin: 0
        },
    },
    formSectionInput: {
        marginBottom: 25,
        width: '100%'
    },
    formSectionHeading: {
        fontWeight: 500,
        marginBottom: 25
    },
    stepButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        '@media(max-width: 480px)': {
            flexDirection: 'column-reverse'
        }
    },
    stepButtonsLeft: {

    },
    stepButtonsRight: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    stepButton: {
        width: 200,
        '@media(max-width: 480px)': {
            marginBottom: 10,
            width: '100%'
        }
    },
    button: {
        display: 'inline-block',
        marginBottom: 20,
        minWidth: 200,
        '&:hover': {
        }
    },
    textButton: {
        minWidth: 'auto',
        padding: 0,
        height: 'auto',
        background: 'none',
        display: 'block',
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },
    manualTextButton: {
        minWidth: 'auto',
        padding: 0,
        height: 'auto',
        marginBottom: 25,
        background: 'none',
        display: 'block',
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },
    selectionSummary: {
        backgroundColor: '#F5F5F5',
        padding: 30,
        marginBottom: 25,
        '& > div': {
            marginBottom: 15
        }
    },
    summaryLabel: {
        color: '#A4A4A4',
        fontSize: 14,
        fontWeight: 500,
        marginBottom: 1
    },
    summaryText: {
        textTransform: 'capitalize',
        fontSize: 16,
        fontWeight: 500,
    },
    loadingIcon: {
        display: 'inline-block',
        marginLeft: 15
    },
    addressProofContainer: {

    },
    certificateConditionSummary: {
        display: 'flex',
        flexDirection: 'column',
        alignItems:'flex-start',
        gap:10,
        backgroundColor: '#EAF3FF',
        padding: '20px 25px',
        borderRadius: 8,
        marginBottom:25
    },
    certificateSummaryHeader: {
        display: 'flex',
        alignItems:'center',
        gap:8,
        justifyContent: 'center'
    },
    certificateSummaryList: {
        color:'#4A4A4A',
        padding: 0,
        '& > li': {
            padding: 0,
            paddingLeft: 16
        },
    }
});